module.exports = __webpack_public_path__ + "img/star6-10.a65874e2.svg";